import routes from './../routes'
import vue from 'vue'
import {filterResponse, filterErrors} from './../client'

export const getCreditReport = () => {
    return vue.http.get(routes.creditReport.report).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}